export default __webpack_public_path__ + "static/media/skyship2.47317f11.webp";